<template>
  <div class="grid-container">
    <!-- 宫格项目 -->
    <div v-for="(item, index) in gridData" :key="index" class="grid-item"
         :class="{ 'last-item': index === gridData.length - 1 }">
      <!-- 图片部分 -->
      <div class="item-image-container">
        <img
            :src="item.imageUrl"
            :alt="item.title"
            class="item-image"
        >
      </div>

      <!-- 文字部分 -->
      <div class="item-text">
        <div class="text-line-1">{{ item.title }}</div>
        <div class="text-line-2">{{ item.subtitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import image1 from '../../static/series/cutbed/图片2.png'
import image2 from '../../static/series/cutbed/图片3.png'
import image3 from '../../static/series/cutbed/图片4.png'
import image4 from '../../static/series/cutbed/图片5.png'
import image5 from '../../static/series/cutbed/图片6.png'

export default {
  name: 'GridComponent',
  data() {
    return {
      // 5项内容数据
      gridData: [
        {
          imageUrl: image1,
          title: '80m/min',
          subtitle: this.$i18n.t('series.bed_data_desc1'),
        },
        {
          imageUrl: image2,
          title: '6000 strokes/min',
          subtitle: this.$i18n.t('series.bed_data_desc2'),
        },
        {
          imageUrl: image3,
          title: this.$i18n.t('series.bed_data_desc3'),
          subtitle: this.$i18n.t('series.bed_data_desc4'),
        },
        {
          imageUrl: image4,
          title: '80 ~ 90 cm',
          subtitle: this.$i18n.t('series.bed_data_desc5'),
        },
        {
          imageUrl: image5,
          title: this.$i18n.t('series.bed_data_desc6'),
          subtitle: this.$i18n.t('series.bed_data_desc7'),
        }
      ]
    };
  }
};
</script>

<style scoped>
/* 容器样式 - 占屏幕90%宽度，更新背景颜色为#f5f5f7 */
.grid-container {
  width: 100%;
  margin: 0 auto; /* 水平居中 */
  background-color: #f5f5f7; /* 新的背景颜色 */
  padding: 16px;
  margin-bottom: 30px;

  /* 宫格布局 - 桌面端5项占满宽度 */
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  box-sizing: border-box;
  border-top: 1px solid #d2d2d7;
}

/* 每个宫格项目样式 */
.grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 12px 8px;
  box-sizing: border-box;
}

/* 图片容器 */
.item-image-container {
  margin-bottom: 8px;
}

/* 图片样式 - 保持50x50大小 */
.item-image {
  width: 70px;
  height: 50px;
  object-fit: cover; /* 保持图片比例，裁剪多余部分 */
  border-radius: 4px; /* 轻微圆角 */
}

/* 文字容器 */
.item-text {
  width: 100%;
}

/* 第一行文字 */
.text-line-1 {
  font-size: 1.0em;
  color: #333;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 第二行文字 */
.text-line-2 {
  font-size: 0.9em;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 平板设备 - 每行显示3项，最后一行2项 */
@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: repeat(3, 1fr);
  }

  /* 最后两项占满一行 */
  .grid-item:nth-last-child(2),
  .grid-item:last-child {
    grid-column: span 1.5;
  }
}

/* 手机端 - 采用2-2-1布局 */
@media (max-width: 480px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 12px;
  }

  /* 最后一项占满整行 */
  .grid-item:last-child {
    grid-column: span 2;
  }

  /* 手机端最后一项左对齐 */
  .last-item {
  }

  /* 调整手机端文字大小 */
  .text-line-1 {
    font-size: 13px;
  }

  .text-line-2 {
    font-size: 11px;
  }
}
</style>
